function stickyHeader() {
	console.log("stickyHeader.js ready!");
	const body = document.body;
	const pageHeader = document.querySelector(".ds-page-header");
		
	if (!pageHeader) return;

	const transparentHeader = pageHeader.classList.contains('uk-navbar-transparent');
	const headerHeight = pageHeader.offsetHeight;
	const contentStart = document.getElementsByTagName('main')[0];
	const scrollUp = "ds-scroll-up";
	const scrollDown = "ds-scroll-down";
	let lastScroll = 0;

	window.addEventListener("load", (event) => {
		const currentScroll = window.pageYOffset;

		if (currentScroll > headerHeight*1.5) {
			pageHeader.classList.add("ds-header-sticky");
			body.classList.add(scrollDown);
		}

	});
		
	window.addEventListener("scroll", (event) => {

		const currentScroll = window.pageYOffset;
		const headerHeightSticky = pageHeader.offsetHeight;

		if (currentScroll <= 0) {
			body.classList.remove(scrollUp);
			pageHeader.classList.remove("ds-header-sticky");
			if (transparentHeader) 	contentStart.removeAttribute("style");
			return;
		
		// } else if (currentScroll < headerHeightSticky) {
			
		// 	if (!transparentHeader) contentStart.removeAttribute("style");
		
		} else if (currentScroll >= headerHeight) {
			
			pageHeader.classList.add("ds-header-sticky");
			//if (!transparentHeader) contentStart.style.paddingTop = headerHeightSticky + 'px';
		
		}

		//scroll direction classes
		if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
			// down
			body.classList.remove(scrollUp);
			body.classList.add(scrollDown);
			contentStart.removeAttribute("style");
		} else if (
			currentScroll < lastScroll &&
			body.classList.contains(scrollDown)
		) {
			// up
			body.classList.remove(scrollDown);
			body.classList.add(scrollUp);
		}
		lastScroll = currentScroll;
	}, false);
}
stickyHeader();